<template>
	<CreateDialog :dialog="createDialog" v-on:close="createDialog = false">
		<template v-slot:title>
			<span v-if="!proformaDetail?.uuid">Create Proforma</span>
			<span v-if="proformaDetail?.uuid">{{ proformaDetail.title }}</span>
			<span v-if="proformaDetail?.barcode" class="orange--text text--darken-4 barcode-font-size">
				#{{ proformaDetail?.barcode }}</span
			>
		</template>
		<template v-slot:body>
			<v-sheet style="height: calc(100vh - 188px)">
				<v-row>
					<v-col md="12">
						<v-form ref="proformaForm">
							<v-row dense v-if="!proformaUpdate">
								<v-col md="9">
									<perfect-scrollbar
										:options="{ suppressScrollX: true }"
										class="scroll custom-box-top-inner-shadow"
										style="position: relative"
									>
										<v-row>
											<v-col md="3">
												<label for="title" class="btx-label mt-2">Milestone</label>
											</v-col>
											<v-col md="9">
												<!-- <ShowValue class="font-level-2-bold" :object="milestone" object-key="phase"
													label="Milestone Title">
												</ShowValue> -->
												<TextInput
													id="tittle"
													hide-details
													placeholder="Title"
													v-if="milestone"
													v-model="milestone.phase"
													disabled
													:loading="pageLoading"
												>
												</TextInput>
											</v-col>
											<v-col md="3">
												<label for="amount" class="btx-label mt-2">Milestone Amount</label>
											</v-col>
											<v-col md="3" class="d-flex align-items-center">
												<!-- <PriceInput v-if="milestone" disabled id="amount" type="number" hide-details
													:loading="pageLoading" placeholder="Amount"
													prepend-inner-icon="mdi-currency-usd" v-model="milestone.amount"
													class="mt-0"
													:rules="[vrules.required(milestone?.amount, 'Milestone Amount')]"
													:class="{
															required: !milestone?.amount,
														}"></PriceInput> -->
												<span class="font-level-2" v-if="milestone.amount">
													{{ formatMoney(milestone.amount) }}</span
												>
												<span class="font-level-2" v-else> {{ formatMoney(0) }}</span>
											</v-col>
											<v-col md="3" class="text-right">
												<label for="milestone_balance" class="btx-label mt-2">Milestone Balance</label>
											</v-col>
											<v-col md="3" class="d-flex align-items-center">
												<!-- {{ milestone.milestone_balance }} -->
												<!-- <PriceInput id="milestone_balance" type="number" hide-details disabled
													:loading="pageLoading" placeholder="Milestone Balance"
													prepend-inner-icon="mdi-currency-usd" v-model="milestoneBalance"
													class="mt-0"></PriceInput> -->
												<span class="font-level-2" v-if="milestoneBalance">
													{{ formatMoney(milestoneBalance) }}</span
												>
												<span class="font-level-2" v-else> {{ formatMoney(0) }}</span>
											</v-col>
											<v-col md="3">
												<label for="name" class="btx-label mt-4">Name</label>
											</v-col>
											<v-col md="9">
												<TextInput
													id="name"
													hide-details
													placeholder="Title"
													v-model="proforma.title"
													:disabled="pageLoading"
													:loading="pageLoading"
												>
												</TextInput>
											</v-col>

											<v-col md="3">
												<label for="proforma_amount" class="btx-label mt-2">Proforma Amount</label>
											</v-col>
											<v-col md="9">
												<PriceInput
													id="proforma_amount"
													type="number"
													hide-details
													:disabled="pageLoading"
													:loading="pageLoading"
													placeholder="Amount"
													prepend-inner-icon="mdi-currency-usd"
													v-model="proforma.amount"
													class="mt-0"
													:rules="[vrules.required(proforma.amount, 'Proforma Amount')]"
													:class="{
														required: !proforma.amount,
													}"
													@keyup="proformaAmountChange"
												></PriceInput>
											</v-col>
										</v-row>
										<v-row dense>
											<v-col md="3">
												<label for="attachment" class="btx-label mt-4">Attachment</label>
											</v-col>
											<v-col md="9">
												<FileUpload
													hide-details
													id="attachment"
													:allowAddMore="false"
													v-model="proforma.attachment"
												>
												</FileUpload>
											</v-col>
											<v-col md="3">
												<label for="certificate" class="btx-label mt-4">Certificate</label>
											</v-col>
											<v-col md="9">
												<FileUpload
													hide-details
													id="certificate"
													:allowAddMore="false"
													v-model="proforma.certificate"
												>
												</FileUpload>
											</v-col>
										</v-row>
										<!-- </template> -->
										<template v-if="!pageLoading">
											<div
												class="middle-header-background d-flex align-items-center justify-content-between my-2"
											>
												<p class="mb-2 px-4">
													Line items<br />
													<span>
														<v-icon small>mdi-progress-question</v-icon> Specify the Line Items for your
														Quotation</span
													>
												</p>
											</div>
											<v-simple-table
												v-if="lineItemsList.length"
												class="bt-table listing-table table-head-sticky"
											>
												<thead>
													<tr>
														<!-- <th class="simple-table-th"> -->
														<!-- <v-checkbox dense @click="selectAllQuotations"></v-checkbox> -->
														<!-- </th> -->
														<th class="simple-table-th">#</th>
														<th>Quote #</th>
														<th class="simple-table-th">Name</th>
														<th class="simple-table-th">Price</th>
														<!--  <th class="simple-table-th">QTY Ordered</th> -->
														<th class="simple-table-th">UOM</th>
														<th class="simple-table-th">QTY</th>
														<!-- <th max-width="150px" class="simple-table-th">Deliverable</th> -->
														<th class="simple-table-th">QTY to be delivered</th>
														<th class="simple-table-th">QTY delivered</th>
														<th class="simple-table-th">Gap</th>
													</tr>
												</thead>
												<tbody v-if="lineItemsList.length">
													<tr class="cursor-pointer" v-for="(row, index) in lineItemsList" :key="index">
														<td>{{ index + 1 }}</td>
														<td>
															<Chip
																tooltip
																tooltip-text="Quotation"
																small
																:text="row.quotation_barcode"
																color="blue darken-4"
															>
															</Chip>
														</td>
														<td>
															<ShowValue :object="row" object-key="line_item_name" label="Name"> </ShowValue>
														</td>
														<td>
															<ShowValue :object="row" object-key="line_item_total_formatted" label="Price">
															</ShowValue>
														</td>
														<td>
															<ShowValue :object="row" object-key="line_item_uom" label="uom"> </ShowValue>
														</td>
														<td>
															<ShowValue :object="row" object-key="line_item_quantity" label="Quantity">
															</ShowValue>
															<!-- {{ row.total_qty_balance }}/{{ row.line_item_quantity }} -->
														</td>
														<td width="80px">
															<ShowValue
																:object="row"
																object-key="qty_to_be_delivered"
																label="Quantity To Be Delivered"
															>
															</ShowValue>
														</td>

														<td width="60px" class="td_column cursor-default simple-table-td">
															<TextInput
																type="number"
																hide-details
																id="qty_delivered"
																placeholder="QTY Delivered"
																@keyup="qtyDelivered(index, row.qty_deliver, row.gap)"
																v-model.number="row.qty_deliver"
															>
															</TextInput>
														</td>
														<td class="td_column cursor-default simple-table-td">
															<!-- <ShowValue :object="row" object-key="gap" label="gap">
															</ShowValue> -->
															{{ row.gap }}/<template>
																<span v-if="row.qty_to_be_delivered">{{ row.qty_to_be_delivered }}</span>
																<span v-else>0</span>
															</template>
														</td>
													</tr>
												</tbody>
												<tfoot v-else>
													<tr>
														<td colspan="11">
															<p class="m-0 row-not-found text-center py-3">
																<img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
																Uhh... There are no task at the moment.
															</p>
														</td>
													</tr>
												</tfoot>
											</v-simple-table>
										</template>
										<template v-else>
											<div class="mx-20 my-40 text-center">
												<v-progress-linear color="orange darken-2" indeterminate height="6"></v-progress-linear>
											</div>
										</template>
									</perfect-scrollbar>
								</v-col>
							</v-row>
							<v-row v-if="proformaUpdate">
								<v-col md="9">
									<v-row dense>
										<v-col md="3">
											<label for="proforma_amount" class="btx-label mt-2 font-level-2">Proforma Amount</label>
										</v-col>
										<v-col md="3" class="mt- d-flex align-items-center">
											<span class="font-level-2" v-if="proformaDetail.amount">
												{{ formatMoney(proformaDetail.amount) }}</span
											>
											<span class="font-level-2" v-else> {{ formatMoney(0) }}</span>
										</v-col>
										<v-col md="3" class="text-right">
											<label for="proforma_amount" class="btx-label mt-2 font-level-2">Proforma Balance</label>
										</v-col>
										<v-col md="3" class="mt- d-flex align-items-center">
											<span class="font-level-2"> {{ formatMoney(proformaBalance1) }}</span>
											<!-- <span class="font-level-2" v-else> {{ formatMoney(0)
											}}</span> -->
										</v-col>
										<v-col md="3">
											<label for="proforma_amount" class="btx-label mt-2 font-level-2"
												>Invoice Collected Amount
											</label>
										</v-col>
										<v-col md="3" class="mt- d-flex align-items-center">
											<span class="font-level-2" v-if="proformaDetail.invoice_amount">
												{{ formatMoney(proformaDetail.invoice_amount) }}</span
											>
											<span class="font-level-2" v-else> {{ formatMoney(0) }}</span>
										</v-col>
										<v-col md="3" class="btx-label text-right">
											<label for="approve_amount" class="btx-label mt-4">Approve Amount</label>
										</v-col>
										<v-col md="3">
											<PriceInput
												id="approve_amount"
												hide-details
												placeholder="Approve Amount"
												v-model="proforma.approve_amount"
												:disabled="pageLoading"
												@keyup="proformaApproveAmount"
												@change="approveAmountChange"
												:loading="pageLoading"
											>
											</PriceInput>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-col md="9">
								<div v-if="proformaUpdate">
									<v-expansion-panels
										flat
										accordion
										tile
										class="mt-4 transparent-panels"
										v-model="updateReturnLineItem"
									>
										<v-expansion-panel>
											<v-expansion-panel-header>
												<!-- <v-checkbox hide-details v-model="update_return_line_item"
													label="Update Return Line Items"></v-checkbox> -->
												Update Return Line Items
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-simple-table
													v-if="updateLineItem.length"
													class="bt-table table-head-sticky"
													style="height: 200px !important; overflow-y: scroll"
												>
													<thead>
														<tr>
															<!-- <th class="simple-table-th"> -->
															<!-- <v-checkbox dense @click="selectAllQuotations"></v-checkbox> -->
															<!-- </th> -->
															<th class="simple-table-th">#</th>
															<th>Quote #</th>
															<th class="simple-table-th">Name</th>
															<th class="simple-table-th">Price</th>
															<!--  <th class="simple-table-th">QTY Ordered</th> -->
															<th class="simple-table-th">UOM</th>
															<th class="simple-table-th">QTY</th>
															<!-- <th max-width="150px" class="simple-table-th">Deliverable</th> -->
															<th class="simple-table-th">QTY to be delivered</th>
															<th class="simple-table-th">QTY delivered</th>
															<th class="simple-table-th">Return</th>
															<th class="simple-table-th">Gap</th>
														</tr>
													</thead>
													<tbody v-if="updateLineItem.length">
														<tr class="cursor-pointer" v-for="(row, index) in updateLineItem" :key="index">
															<td>{{ index + 1 }}</td>
															<td>
																<Chip
																	tooltip
																	tooltip-text="Quotation"
																	small
																	:text="row.quotation_barcode"
																	color="blue darken-4"
																>
																</Chip>
															</td>
															<td>
																<ShowValue :object="row" object-key="line_item_name" label="Name"> </ShowValue>
															</td>
															<td>
																<ShowValue :object="row" object-key="line_item_total_formatted" label="Price">
																</ShowValue>
															</td>
															<td>
																<ShowValue :object="row" object-key="line_item_uom" label="uom"> </ShowValue>
															</td>
															<td>
																<ShowValue :object="row" object-key="line_item_quantity" label="Quantity">
																</ShowValue>
															</td>
															<td width="80px">
																<ShowValue
																	:object="row"
																	object-key="qty_to_be_delivered"
																	label="Quantity To Be Delivered"
																>
																</ShowValue>
															</td>

															<td width="60px" class="td_column cursor-default simple-table-td">
																<!-- <TextInput hide-details id="qty_delivered" placeholder="QTY Delivered"
														@keyup="qtyDelivered(index, row.qty_deliver, row.qty_to_be_delivered)"
														v-model.number="row.qty_deliver">
													</TextInput> -->
																<ShowValue :object="row" object-key="total_qty_delivered" label="Quantity Deliver">
																</ShowValue>
															</td>
															<td class="td_column cursor-default simple-table-td" width="150px">
																<!-- <ShowValue :object="row" object-key="return" label="return">
													</ShowValue> -->
																<TextInput
																	type="number"
																	hide-details
																	id="return"
																	placeholder="Return"
																	v-model.number="row.return_qty"
																	@keyup="returnQtyChange(index, row.total_qty_delivered, row.return_qty)"
																>
																</TextInput>
															</td>
															<td class="td_column cursor-default simple-table-td">
																<!-- <ShowValue :object="row" object-key="gap" label="gap">
																</ShowValue> -->
																{{ row.gap }}/<template>
																	<span v-if="row.qty_to_be_delivered">{{ row.qty_to_be_delivered }}</span>
																	<span v-else>0</span>
																</template>
															</td>
														</tr>
													</tbody>
													<tfoot v-else>
														<tr>
															<td colspan="11">
																<p class="m-0 row-not-found text-center py-3">
																	<img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
																	Uhh... There are no task at the moment.
																</p>
															</td>
														</tr>
													</tfoot>
												</v-simple-table>
											</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
									<v-expansion-panels
										flat
										tile
										class="mt-4 transparent-panels"
										v-model="generateInvoice"
										@change="generateInvoiceChange"
									>
										<v-expansion-panel>
											<v-expansion-panel-header>
												<v-checkbox hide-details v-model="do_invoice" label="Do Invoice"
													>Generate Invoice</v-checkbox
												>
											</v-expansion-panel-header>
											<v-expansion-panel-content>
												<v-form ref="invoiceFrom">
													<v-row dense>
														<v-col md="12">
															<perfect-scrollbar
																:options="{ suppressScrollX: true }"
																class="scroll custom-box-top-inner-shadow"
																style="position: relative"
															>
																<v-row class="px-1">
																	<v-col md="3">
																		<label for="invoice_title" class="mt-4 btx-label">Title</label>
																	</v-col>
																	<v-col md="9">
																		<TextInput
																			hide-details
																			:disabled="pageLoading"
																			:loading="pageLoading"
																			id="invoice_title"
																			placeholder="Invoice Title"
																			v-model="invoice.title"
																		>
																		</TextInput>
																	</v-col>
																	<v-col md="3">
																		<label for="invoice_no" class="mt-4 btx-label">Invoice no</label>
																	</v-col>
																	<v-col md="3">
																		<TextInput
																			hide-details
																			:disabled="pageLoading"
																			:loading="pageLoading"
																			id="invoice_no"
																			placeholder="Invoice No"
																			v-model="invoice.invoice_no"
																		>
																		</TextInput>
																	</v-col>
																	<v-col md="3" class="text-right btx-label">
																		<label for="invoice_date" class="mt-4 required">Invoice Date</label>
																	</v-col>
																	<v-col md="3">
																		<DatePicker
																			hide-details
																			:disabled="pageLoading"
																			:loading="pageLoading"
																			id="invoice_date"
																			v-model="invoice.invoice_date"
																			:rules="[vrules.required(invoice.invoice_date, 'Date')]"
																			:class="{
																				required: !invoice.invoice_date,
																			}"
																		></DatePicker>
																	</v-col>
																	<!-- <v-col md="3">
														<label for="status" class=" mt-4 ">Status</label>
													</v-col>
													<v-col md="3">
														<AutoCompleteInput v-if="statusList" hide-details
															:items="statusList" id="status" placeholder="Status"
															item-text="text" item-value="value"
															v-model="invoice.invoice_invoice_status">
														</AutoCompleteInput>
													</v-col> -->
																	<v-col md="3">
																		<label for="invoice_amount" class="btx-label mt-4">Invoice Amount</label>
																	</v-col>
																	<v-col md="3" class="d-flex align-items-center">
																		<!-- <PriceInput id="invoice_amount" hide-details
															placeholder="Invoice Amount" disabled v-model="invoice.amount"
															:loading="pageLoading">
														</PriceInput> -->
																		<span class="font-level-2" v-if="invoice.amount">
																			{{ formatMoney(proformaBalance1) }}</span
																		>
																		<span class="font-level-2" v-else> {{ formatMoney(0) }}</span>
																	</v-col>
																	<v-col md="3" class="text-right btx-label">
																		<label for="collected_amount" class="btx-label mt-4 required"
																			>Collected Amount</label
																		>
																	</v-col>
																	<v-col md="3" class="d-flex align-items-center">
																		<PriceInput
																			id="collected_amount"
																			hide-details
																			placeholder="Collected Amount"
																			:rules="[vrules.required(invoice.collected_amount, 'Collected Amount')]"
																			:class="{
																				required: !invoice.collected_amount,
																			}"
																			v-model="invoice.collected_amount"
																			:loading="pageLoading"
																			@keyup="invoiceCollectedAmountChange"
																		>
																		</PriceInput>
																	</v-col>
																	<!-- <v-col md="3" class="">
												<label for="amount" class=" mt-4">Amount</label>
											</v-col>
											<v-col md="3">
												<PriceInput id="amount" type="number" hide-details :disabled="pageLoading"
													:loading="pageLoading" placeholder="Amount"
													prepend-inner-icon="mdi-currency-usd" v-model="invoice.amount"
													:rules="[vrules.required(invoice.amount, 'Amount')]" :class="{
														required: !invoice.amount,
													}"></PriceInput>
											</v-col> -->
																	<v-col md="3">
																		<label for="balance" class="mt-4 btx-label">Balance</label>
																	</v-col>
																	<v-col md="3" class="d-flex align-items-center">
																		<!-- <PriceInput id="balance" type="number" hide-details disabled
															:loading="pageLoading" placeholder="Balance"
															prepend-inner-icon="mdi-currency-usd" v-model="invoiceBalance">
														</PriceInput> -->
																		<span v-if="invoiceBalance"> {{ formatMoney(invoiceBalance) }}</span>
																		<span class="font-level-2" v-else> {{ formatMoney(0) }}</span>
																	</v-col>
																</v-row>
																<v-row>
																	<v-col md="3">
																		<label for="attachment" class="mt-4 btx-label">Attachment</label>
																	</v-col>
																	<v-col md="9">
																		<FileUpload hide-details id="attachment" v-model="invoice.attachment">
																		</FileUpload>
																	</v-col>
																	<v-col md="3">
																		<label for="remark" class="mt-4 btx-label">Remark</label>
																	</v-col>
																	<v-col color="9">
																		<TextAreaInput
																			:disabled="pageLoading"
																			:loading="pageLoading"
																			id="remark"
																			placeholder="Remark"
																			v-model="invoice.remark"
																		>
																		</TextAreaInput>
																	</v-col>
																</v-row>
															</perfect-scrollbar>
														</v-col>
													</v-row>
												</v-form>
											</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
								</div>
							</v-col>
						</v-form>
					</v-col>
				</v-row>
			</v-sheet>
		</template>
		<template v-slot:action>
			<v-btn depressed tile :disabled="pageLoading" v-on:click="$router.go(-1)"> Close </v-btn>
			<v-btn @click="createProforma()" class="white--text" depressed color="blue darken-4" tile>
				Save
			</v-btn>
		</template>
	</CreateDialog>
</template>
<script>
// import { CreateProforma, /* updateProforma */ } from "@/core/lib/project.lib";
import { SET_ERROR, SET_MESSAGE } from "@/core/services/store/common.module";
// import Dialog from "@/view/components/Dialog";
import CreateDialog from "@/view/components/CreateDialog";
import TextInput from "@/view/components/TextInput";
import FileUpload from "@/view/components/FileUpload";
import TextAreaInput from "@/view/components/TextAreaInput";
import {
	UPDATE_PROFORMA,
	GET_PROFORMA_BY_PROJECT,
	CREATE_PROFORMA,
} from "@/core/services/store/proforma.module.js";
import { createInvoice } from "@/core/lib/project.lib";
import { getMilestoneByUUID, GetProject /* getProforma */ } from "@/core/lib/project.lib";
// import TextAreaInput from "@/view/components/TextAreaInput";
import ShowValue from "@/view/components/ShowValue";
// import ShowPrice from "@/view/components/ShowPrice";
import Chip from "@/view/components/Chip";
import PriceInput from "@/view/components/PriceInput";
import DatePicker from "@/view/components/DatePicker";
// import AutoCompleteInput from "@/view/components/AutoCompleteInput";
// import { mapGetters } from "vuex";
import { getData, deleteData } from "@/core/services/local.service";
import { mapGetters } from "vuex";
import {
	GET_MILESTONE_DELIVERABLE,
	GET_PROFORMA_By_UUID,
} from "@/core/services/store/proforma.module.js";
import ListingMixin from "@/core/mixins/listing.mixin.js";
export default {
	name: "create-proforma",
	title: "Create Proforma",
	mixins: [ListingMixin],
	components: {
		// Dialog,
		// AutoCompleteInput,
		DatePicker,
		ShowValue,
		TextInput,
		FileUpload,
		TextAreaInput,
		// ShowPrice,
		Chip,
		CreateDialog,
		PriceInput,
	},

	data() {
		return {
			createDialog: true,
			isDeliveryExistDialog: false,
			contact_person: [],
			proformaBalance: null,
			uuid: null,
			contentLoading: false,
			do_invoice: false,
			quantity_to_delivered: null,
			proforma_qty_to_be_delivered: null,
			proforma_barcode: "PF-001",
			lineItemsList: [],
			updateReturnLineItem: null,
			update_return_line_item: false,
			generateInvoice: false,
			proformaDetail: {
				amount: null,
				proforma_title: null,
				proforma_price: null,
				proforma_amount: null,
				// milestone_price:3000,
				barcode: null,
				milestone_price: null,
				balance: null,
			},
			proforma: {
				proforma_price: null,
				approve_amount: null,
				title: null,
				proforma_amount: null,
				amount: null,
				attachment: [],
				certificate: null,
				invoice_amount: null,
				milestone_balance: null,
				milestone_amount: null,
			},
			invoice: {
				id: null,
				invoice_invoice_status: null,
				invoice_date: null,
				amount: null,
				title: null,
				attachment: [],
				// amount: null,
				collected_amount: null,
				balance: null,
			},
			updateLineItem: [
				// {
				// 	quotation_barcode: "QA-001",
				// 	qty_to_be_delivered: 1,
				// 	line_item_quantity: 2,
				// 	line_item_uom: 1,
				// 	line_item_total_formatted: 2,
				// 	line_item_name: "Line Items 1",
				// 	return: 4,
				// },
				// {
				// 	quotation_barcode: "QA-001",
				// 	qty_to_be_delivered: 1,
				// 	line_item_quantity: 2,
				// 	line_item_uom: 1,
				// 	line_item_total_formatted: 2,
				// 	line_item_name: "Line Items 1",
				// 	return: 4,
				// },
			],
			projectUUID: null,
			mileUUID: null,
			project: null,
			milestone: {
				phase: null,
				amount: null,
				milestone_balance: null,
			},
			proformaUpdate: false,
			// isLineItemExist: null,
			proformaUUID: null,
			statusList: [
				{
					value: 1,
					text: "PAID",
				},
				{
					value: 2,
					text: "UNPAID",
				},
				{
					value: 3,
					text: "PARTIAL-PAID",
				},
			],
		};
	},
	methods: {
		async createProforma() {
			const _this = this;
			const formErrors = _this.validateForm(_this.$refs.proformaForm);
			if (formErrors.length) {
				_this.$store.commit(SET_ERROR, _this.errors.concat(formErrors));
				return false;
			}
			if (!_this.$refs.proformaForm.validate()) {
				return false;
			}
			_this.pageLoading = true;

			try {
				if (_this.proformaUpdate) {
					let lineItemWithReturnValue = [];
					if (this.updateLineItem.length) {
						lineItemWithReturnValue = this.updateLineItem.filter((ele) => ele.return_qty);
					}
					let body = null;
					if (this.updateReturnLineItem === 0) {
						body = {
							uuid: _this.proformaDetail.uuid,
							params: {
								return_items: lineItemWithReturnValue,
								amount_approved: _this.proforma.approve_amount,
							},
						};
					} else {
						body = {
							uuid: _this.proformaDetail.uuid,
							params: {
								amount_approved: _this.proforma.approve_amount,
							},
						};
					}
					await _this.$store.dispatch(UPDATE_PROFORMA, body);
					if (_this.do_invoice) {
						const params = {
							proforma: _this.proformaDetail.id,
							project: _this.project.id,
							invoice_no: _this.invoice.invoice_no,
							title: _this.invoice.title,
							date: _this.invoice.invoice_date,
							amount: _this.invoice.amount,
							collected_amount: _this.invoice.collected_amount,
							remark: _this.invoice.remark,
							files: _this.invoice.attachment,
						};
						await createInvoice(params);
					}
					_this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Proforma has been updated." },
					]);
				} else {
					const params = {
						title: _this.proforma.title,
						project: _this.project.id,
						project_milestone: this.milestone.id,
						customer: _this.project.contact,
						amount: _this.proforma.amount,
						files: _this.proforma.attachment,
						certificate: _this.proforma.certificate[0],
						// invoice_amount: this.proforma.invoice_amount,
						deliverables: _this.lineItemsList,
					};
					await this.$store.dispatch(CREATE_PROFORMA, params);
					_this.$store.commit(SET_MESSAGE, [
						{ model: true, message: "Success ! Proforma has been created." },
					]);
				}
				deleteData("milestone_line_items");
				_this.createDialog = false;
				_this.proforma = {
					title: null,
					amount: null,
					attachment: [],
					certificate: [],
					invoice_amount: null,
				};
				this.$router.go(-1);
			} catch (error) {
				_this.$store.commit(SET_ERROR, [{ model: true, message: error.data.message }]);
			} finally {
				_this.pageLoading = false;
			}
		},
		async loadProforma() {
			this.pageLoading = true;
			try {
				await this.$store.dispatch(GET_PROFORMA_BY_PROJECT, this.project.uuid);
				this.pageLoading = false;
			} catch (error) {
				this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
				this.pageLoading = false;
			}
		},
		async getProject() {
			try {
				this.pageLoading = true;
				const project = await GetProject(this.$route.params.uuid);
				this.project = project[0];
				// this.proformaBalance = this.milestone.amount - this.proforma.proforma_amount
			} catch (error) {
				this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
			} finally {
				this.pageLoading = false;
			}
		},
		async getMilestone() {
			const _this = this;
			try {
				_this.pageLoading = false;
				const milestone = await getMilestoneByUUID(this.$route.query.mileUUID);
				_this.milestone = milestone[0];
			} catch (error) {
				_this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
			} finally {
				_this.pageLoading = false;
			}
		},
		proformaAmountKeyUp() {
			this.proformaBalance = this.milestone.amount - this.proforma.proforma_amount;
		},
		returnQtyChange(index, qty_to_be_delivered, return_qty) {
			if (return_qty > qty_to_be_delivered) {
				this.updateLineItem[index].return_qty = qty_to_be_delivered;
			}
			// if (this.updateLineItem[index].return_qty >= this.updateLineItem[index].gap) {
			// 	this.updateLineItem[index].gap = Number(this.updateLineItem[index].return_qty) + Number(this.updateLineItem[index].gap)
			// } else {
			// 	console.log(Number(this.updateLineItem[index].gap) - Number(this.updateLineItem[index].return_qty));
			// 	this.updateLineItem[index].gap = Number(this.updateLineItem[index].gap) - Number(this.updateLineItem[index].return_qty)
			// }
			// if (this.updateLineItem[index].return_qty < this.updateLineItem[index].gap) {
			// 	this.updateLineItem[index].gap = Number(this.updateLineItem[index].gap) - Number(this.updateLineItem[index].return_qty)
			// }
		},
		// async getProforma() {
		// 	try {
		// 		const proforma = await getProforma(this.$route.query.proformaUUID);
		// 		console.log(proforma);
		// 		// this.milestoneId = this.milestone.id
		// 	} catch (error) {
		// 		this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
		// 	} finally {
		// 		// this.pageLoading = false;
		// 	}
		// },
		qtyDelivered(index, qty_to_delivered, gap) {
			if (qty_to_delivered > gap) {
				this.lineItemsList[index].qty_deliver = gap;
			}
		},
		qtyDeliveredKeyPress($event, index, qty_to_delivered /* gap */) {
			console.log(Number($event.key));
			console.log(qty_to_delivered);
			// if ($event.key > qty_to_delivered) {
			// 	this.lineItemsList[index].gap = this.lineItemsList[index].gap - Number($event.key);
			// } else {
			// 	this.lineItemsList[index].gap = this.lineItemsList[index].gap + Number($event.key);
			// }
		},
		async milestoneDeliverable() {
			let milestone_line_items = getData("milestone_line_items");
			if (milestone_line_items) {
				const params = {
					quotation: null,
					filter_deliverable_ids: milestone_line_items,
				};
				try {
					this.pageLoading = true;
					const { deliverables } = await this.$store.dispatch(GET_MILESTONE_DELIVERABLE, {
						uuid: this.$route.query.mileUUID,
						params: params,
					});
					deliverables.forEach((ele) => {
						if (!ele?.gap) {
							ele.qty_deliver = 0;
						}
					});
					this.lineItemsList = deliverables;
				} catch (error) {
					this.logError(error);
				} finally {
					this.pageLoading = false;
				}
			}
		},
		async initProforma() {
			try {
				this.pageLoading = true;
				const data = await this.$store.dispatch(GET_PROFORMA_By_UUID, this.$route.query.proformaUUID);
				this.updateLineItem = data[0].proforma_delivered_items;
				this.proformaDetail = data[0];
				this.proforma.approve_amount = this.proformaDetail.approved_amount;
				// this.proformaAmount = this.formatMoney(1000)
				this.invoice.amount = this.proformaDetail.balance;
			} catch (error) {
				this.logError(error);
			} finally {
				this.pageLoading = false;
			}
		},
		async proformaAmountChange() {
			const _this = this;
			if (_this.proforma.amount > _this.milestone.milestone_balance) {
				_this.$store.commit(SET_ERROR, [
					{
						model: true,
						message: "Proforma amount can not be greater then remaining milestone balance!",
					},
				]);
				_this.proforma.amount = _this.milestone.milestone_balance;
			}
		},
		async generateBarcode() {
			this.genrateBarcode("performa-invoice").then((output) => {
				this.proformaDetail.barcode = output;
			});
		},
		proformaApproveAmount() {
			if (this.proforma.approve_amount > this.proformaDetail.amount) {
				this.proforma.approve_amount = this.proformaDetail.amount;
			}

			if (this.proforma.approve_amount > 0) {
				this.invoice.amount = this.proforma.approve_amount;
			} else {
				this.invoice.amount = this.proformaDetail.balance;
			}
		},
		visibilityReturnLinePanel() {
			if (this.proforma.approve_amount < this.proformaDetail.amount) {
				this.updateReturnLineItem = 0;
			} else {
				this.updateReturnLineItem = false;
			}
		},
		approveAmountChange() {
			this.visibilityReturnLinePanel();
			if (this.proformaDetail.invoice_amount > this.proforma.approve_amount) {
				this.proforma.approve_amount = this.proformaDetail.invoice_amount;
			}
		},
		invoiceCollectedAmountChange() {
			if (this.invoice.collected_amount > this.proformaBalance1) {
				this.invoice.collected_amount = this.proformaBalance1;
			}
		},
		doInvoiceChange() {
			if (this.do_invoice && !this.proforma.approve_amount) {
				this.proforma.approve_amount = this.proformaDetail.balance;
			} else {
				this.proforma.approve_amount = null;
			}
		},
		generateInvoiceChange() {
			if (this.generateInvoice === 0) {
				this.do_invoice = true;
			} else {
				this.do_invoice = false;
			}
		},
	},
	// watch: {
	// 	currentProforma(newProject) {
	// 		if (newProject) {
	// 			this.proforma = {
	// 				title: newProject.title,
	// 				amount: newProject.amount,
	// 				invoice_amount: newProject.invoice_amount,
	// 			};
	// 		}
	// 	},
	// },
	computed: {
		...mapGetters(["errors"]),
		invoiceBalance: {
			get() {
				return this.proformaBalance1 - this.invoice.collected_amount;
			},
			// setter
			set(newValue) {
				return newValue;
			},
		},
		milestoneBalance: {
			get() {
				if (this.milestone?.milestone_balance - this.proforma?.amount) {
					return this.milestone?.milestone_balance - this.proforma.amount;
				} else {
					return 0;
				}
			},
			// setter
			set(newValue) {
				return newValue;
			},
		},
		proformaBalance1() {
			return this.proforma?.approve_amount - this.proformaDetail.invoice_amount;
		},
	},
	async mounted() {
		this.proformaUUID = this.$route.query.proformaUUID;
		if (this.$route.query.proformaUUID) {
			this.proformaUpdate = true;
		}
		if (!this.$route.query.proformaUUID) {
			await this.generateBarcode();
			await this.milestoneDeliverable();
		}
		if (this.$route.query.proformaUUID) {
			await this.initProforma();
			this.visibilityReturnLinePanel();
		}
		await this.getMilestone();
		await this.getProject();
	},
};
</script>
